import React, { useState, useCallback } from 'react';
import { Drawer } from '@material-ui/core';
import {
  Edit, TabbedForm, TextInput, DateInput, ReferenceInput, SelectInput, required, BooleanInput, FormTab, useRefresh, ReferenceManyField, ReferenceField, Datagrid, NumberInput, TextField,
  DateField,AutocompleteInput,BooleanField,EditButton
} from "react-admin";
import { CreateToolbar } from "../../CreateToolbar";
import { useStyles } from "../../formStyles";
import VSDeleteButton from "../../VSDeleteButton";
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import CDeleteButton from "../../common/CDeleteButton";
import DocumentsCreate from './DocumentsCreate';
import ConfigCreate from './ConfigCreate';
import CreateFOPayment from './CreateFOPayment';
import EditFOPayment from './EditFOPayment';

const myStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  list: {
    flexGrow: 1,
    transition: theme.transitions.create(['all'], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  listWithDrawer: {
    marginRight: 300,
  },
  drawerPaper: {
    zIndex: 100,
    marginTop: 50,
    width: 650,
  },
}));

const DisplayFileLink = (props) => {
  let { record } = props;

  if (record.docUrl && record.docUrl.length > 0)
    return (
      <a href={record.docUrl}>View File</a>
    )
  else {
    return null
  }
}

export const VendorEdit = (props) => {
  const classes = useStyles({});
    const myclasses = myStyles({});
    const refresh = useRefresh();
    const [isaddTpa, setIsAddTpa] = useState(false);
    const [isaddFoConfig, setIsAddFoConfig] = useState(false);
    const [isEditFoConfig, setIsEditFoConfig] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isaddDocuments, setIsAddDocuments] = useState(false);
    const [isaddCircularDocuments, setIsAddCircularDocuments] = useState(false);
    let propsObj = { ...props };
    if (propsObj.permissions) {
      let resourcename = `/${props.resource}`;
      let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
      if (myPermissions.length > 0) {
        let p = myPermissions[0];
        propsObj.hasList = (p.View == 1) ? true : false;
        propsObj.hasShow = (p.View == 1) ? true : false;
        propsObj.hasEdit = (p.Edit == 1) ? true : false;
        propsObj.hasDelete = (p.Delete == 1) ? true : false;
        propsObj.hasCreate = (p.Create == 1) ? true : false;
        propsObj.hasExport = (p.Export == 1) ? true : false;
      }
    }
    const closeEdit = () => {
      setIsAddTpa(false);
      setIsAddFoConfig(false);
      setIsEditFoConfig(false);
      setIsAddDocuments(false);
      setIsAddCircularDocuments(false);
      refresh();
    }
    const onCancel = () => {
      setIsAddTpa(false)
      setIsAddDocuments(false);
      setIsAddFoConfig(false);
      setIsEditFoConfig(false);
      setIsAddCircularDocuments(false);
    }
    const handleClose = useCallback(() => {
      setIsAddTpa(false);
      setIsAddDocuments(false);
      setIsAddCircularDocuments(false);
      setIsAddFoConfig(false);
      //setIsAccountServiceAdd(false);
    }, []);
    const Edit_Button = (props) => {
      return (
          <Button variant="contained"
              onClick={() => {
                  props.onClick(props.record.id);
              }}
              color="primary">
              Edit 
          </Button>
      )
  }
  return (
    <React.Fragment>
    <Edit title="Vendor Edit" {...propsObj}>

      
              <TabbedForm variant="outlined" redirect="list" toolbar={<CreateToolbar {...propsObj} />}>
                <FormTab label="Vendor Detail ">
                <TextInput source="code" label="Code" formClassName={classes.one_three_input} disabled={true}/>
                <TextInput source="name" label="Name" validate={[required()]} formClassName={classes.two_three_input} />
                <TextInput source="phoffice" label="Phone(Off)." formClassName={classes.last_three_input} />

                <TextInput source="email" label="email" formClassName={classes.one_three_input} />
                <TextInput source="phmobile" label="Mobile" formClassName={classes.two_three_input} />
                <TextInput source="gstNo" label="GST Number" formClassName={classes.last_three_input} />

                
                <TextInput source="panno" label="Pan Number" formClassName={classes.one_three_input} />
                <TextInput source="stateCode" label="State Code" formClassName={classes.two_three_input}  />
                <TextInput source="state" label="State" validate={[required()]} formClassName={classes.last_three_input} />

                <TextInput source="city" label="City" validate={[required()]} formClassName={classes.one_three_input} />
                <TextInput source="add1" label="Address 1" validate={[required()]} formClassName={classes.two_three_input} />
                <TextInput source="add2" label="Address 2" formClassName={classes.last_three_input} />

                <TextInput source="add3" label="Address 3" formClassName={classes.one_three_input} />
                <TextInput source="pincode" label="Pincode" validate={[required()]} formClassName={classes.two_three_input} />
                <TextInput source="cpName1" label="Contact Person 1" formClassName={classes.last_three_input} />

                <TextInput source="cpMob1" label="Contact Person 1 Mobile" formClassName={classes.one_three_input} />
                <TextInput source="cpRes1" label="Contact Person 1 ResiID" formClassName={classes.two_three_input} />
                <ReferenceInput label="Tax Type" perPage={5000} source="taxTypeId" filter={{ type: 'TT' }} reference="lookups" formClassName={classes.last_three_input}>
                            <SelectInput optionText="name"  />
                  </ReferenceInput>

                <NumberInput  label="Tax Percentage"  source="taxPercentage"   formClassName={classes.one_three_input} /> 
                <ReferenceInput label="Area" source="areaId" reference="areas" perPage={20000}  sort={{ field: 'name', order: 'ASC' }} formClassName={classes.two_three_input} filterToQuery={searchText => ({ 'name~like': searchText })}>
                <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
                  </ReferenceInput>
                <BooleanInput source="isActive" label="Active" initialValue={true} formClassName={classes.last_three_input} />
        </FormTab>
          <FormTab label="Configration ">
                    <Button onClick={() => { setIsAddTpa(true); }}
                      color="secondary">
                      Add Config
                    </Button>
                    <ReferenceManyField fullWidth={true}
                      addLabel={false}
                      sort={{ field: 'id', order: 'ASC' }}
                      reference="vendor-inv-dets"
                      target="vendorId">
                      <Datagrid>
                        <VSDeleteButton {...props} />
                        {/* <TPAEditButton setHospitalDetEdit={setgridRecordEdit} /> */}
                        <ReferenceField link={false} label="Claim Type" source="claimTypeId" reference="lookups" fullWidth={true} >
                          <TextField source="name" />
                        </ReferenceField>
                        <TextField fullWidth={true} source="tatindays" label="Tat in days" />
                        <TextField fullWidth={true} source="billingPercentage" label="Billing Percentage" />
                        <TextField fullWidth={true} source="billingAmount" label="Billing Amount" />
                        <TextField fullWidth={true} source="professionalFee" label="Professional Fee" />
                        <ReferenceField link={false} label="Incentive Type" source="incentiveType" reference="lookups" fullWidth={true} >
                          <TextField source="name" />
                        </ReferenceField>
                        <TextField fullWidth={true} source="incentiveAmt" label="Incentive Amt" />
                        <ReferenceField link={false} label="other Charges Type" source="otherChargesType" reference="lookups" fullWidth={true} >
                          <TextField source="name" />
                        </ReferenceField>
                        <TextField fullWidth={true} source="otherCharges" label="Other Charges Amt" />
                        <TextField fullWidth={true} source="remarks" label="Remarks" />
                        <TextField fullWidth={true} source="other" label="Other" />
        
                      </Datagrid>
                    </ReferenceManyField>
                  </FormTab>
                  <FormTab label="FO Fee Configration ">
                    <Button onClick={() => { setIsAddFoConfig(true); }}
                      color="secondary">
                      Add Config
                    </Button>
                    <ReferenceManyField fullWidth={true}
                      addLabel={false}
                      sort={{ field: 'id', order: 'ASC' }}
                      reference="vendor-fo-fee-dets"
                      target="vendorId">
                      <Datagrid>
                        <VSDeleteButton {...props} />
                        
                        {<Edit_Button label="Modify" {...props} onClick={(id) =>{
                  setIsEditFoConfig(true);
                  setSelectedRecord(id);
                }} />}
                
                        <ReferenceField link={false} label="Policy Type" source="policyTypeId" reference="lookups" fullWidth={true} >
                          <TextField source="name" />
                        </ReferenceField>
                        <BooleanField fullWidth={true} source="isInsured" label="Insured"/>
                        <BooleanField fullWidth={true} source="isHospitalised" label="Hospitalised"/>
                        <BooleanField fullWidth={true} source="iscompleted" label="Completed"/>
                        <TextField fullWidth={true} source="professionalFee" label="Professional Fee" />
                        <TextField fullWidth={true} source="remarks" label="Remarks" />
             ,
          
                      </Datagrid>
                    </ReferenceManyField>
                  </FormTab>
        <FormTab label=" Documents">
            <div style={{ flex: 1 }}>
              <Button onClick={() => { setIsAddDocuments(true); }}>Add New</Button>

            </div>

            <ReferenceManyField fullWidth={true}
              addLabel={false}
              sort={{ field: 'id', order: 'ASC' }}
              reference="broker-docs"
              target="brokerId">
              <Datagrid>
                <CDeleteButton {...props} />
                {/* <TextField label="ITP" source="itp" />
                <TextField label="BillNo" source="billNo" /> */}
                <DateField showTime={true} label="Created Date" source="createdDate" locales="fr-FR" />
                {/* <TextField label="Document Type" source="docType" /> */}
                <ReferenceField source="typeId" reference="lookups" label="Type" link={false}>
                  <TextField source="name" />
                </ReferenceField>
                <TextField label="Remarks" source="remarks" />
                <DisplayFileLink label="Document URL" source="docUrl" />
                {/* <UploadDocument onClick={(record) => { setIsEditDocumentRecord(record); setIsEditDocuments(true); }} label="Upload Document" /> */}
              </Datagrid>
            </ReferenceManyField>
          </FormTab>
      </TabbedForm>


    </Edit>
    <Drawer
            anchor="right"
            onClose={handleClose}
            classes={{ paper: myclasses.drawerPaper, }}
            open={isaddTpa || isEditFoConfig || isaddDocuments|| isaddFoConfig || isaddCircularDocuments} >
            {isaddTpa && <ConfigCreate
          onClose={closeEdit}
          onCancel={onCancel}
          id={props.id}
          {...props} />}
          {isaddFoConfig && <CreateFOPayment
          onClose={closeEdit}
          onCancel={onCancel}
          id={props.id}
          {...props} />}
          {isEditFoConfig && <EditFOPayment
          onClose={closeEdit}
          onCancel={onCancel}
          selectedId={selectedRecord}
          {...props} />}
            {isaddDocuments && <DocumentsCreate
              onClose={closeEdit}
              onCancel={onCancel}
              vendorId={props.id}
              {...props} />}
            
          </Drawer>
    </React.Fragment>
  );
};
